module.exports = __webpack_public_path__ + "img/icb-co-novice-e@3x.864ef17f.png";